import { ITileId } from "../store/types";

export const SELECT_TILE = "selectTile/SELECT_TILE";

export const selectTile = (target: ITileId | null) => ({
  type: SELECT_TILE,
  payload: target,
});
